module.exports = __webpack_public_path__ + "92d6870b70ea162154e2af82bd867a70.jpg";